import React, { Component } from "react";
import * as designerActions from "../../redux/actions/designer";
import {
  ActivityIndicator,
  Button as RNButton,
  FlatList,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../../components/MenuButton";
import WebHeading from "../../components/WebHeading";
import goTo, { goBack } from "../../utils/goTo";
import { errorColors, RepositColours, RepositStyles } from "../../utils/styles";
import Icon from "react-native-vector-icons/FontAwesome";
import { serializeDesign } from "./KitConstants";
import Swipeout from "react-native-swipeout";

const styles = StyleSheet.create({
  listItem: {
    maxWidth: 400,
    minWidth: 350,
    height: 110,
    borderBottomColor: "#E2E2E2",
    borderBottomWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 20,
  },
  textInputTitle: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
  },
  textInput: {
    fontSize: 16,
    height: Platform.OS === "android" ? 40 : 25,
    textAlign: "center",
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 300,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    borderBottomColor: "#D2D2D2",
  },
  bodyTextContainer: {
    flex: 1,
    alignItems: "center",
  },
  wrapper: {
    backgroundColor: "white",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 30,
  },
  bodyText: {
    marginVertical: 10,
  },
  stepBox: {
    flexDirection: "row",
    marginBottom: 50,
    marginHorizontal: 50,
  },
  addressBox: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    marginHorizontal: 20,
    marginVertical: 10,
  },
});

class InverterSystemItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeRowKey: null,
    };
  }

  getSystemDetails = () => {
    const {
      index,
      inverter,
      battery,
      pvConnected,
      pvPhases,
      inverterTypes,
      batteryTypes,
    } = this.props;

    const inverterFragment = inverter.value && (
      <Text>{inverterTypes[inverter.value].displayName}</Text>
    );
    const batteryFragment = (
      <Text>
        {battery.value
          ? batteryTypes[battery.value].displayName
          : "Battery not present"}
      </Text>
    );

    let solarText;
    if (!inverter.value) {
      solarText = null;
    } else if (pvPhases.value) {
      switch (pvPhases.value) {
        case 1:
          solarText = "Single phase solar";
          break;
        case 3:
          solarText = "Three phase solar";
          break;
        default:
          solarText = null;
          break;
      }
    } else {
      solarText = pvConnected.value ? "Solar present" : "Solar not present";
    }
    const solarFragment = solarText && <Text>{solarText}</Text>;

    return (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Text style={{ color: RepositColours.lightGrey, textAlign: "left" }}>
          Inverter Set {index}
        </Text>
        {inverterFragment}
        {solarFragment}
        {batteryFragment}
      </View>
    );
  };

  render() {
    const { index, inverter, battery, pvConnected, pvPhases, onSelected } =
      this.props;

    const numErrors = [inverter, battery, pvConnected, pvPhases].filter(
      (val) => val.error
    ).length;
    const errorText = numErrors ? (
      <Text style={{ color: errorColors.orange }}>
        {numErrors} issue{numErrors === 1 ? "" : "s"}
      </Text>
    ) : null;

    const needsFilling = !inverter.value;

    const details = needsFilling ? (
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Text style={{ color: RepositColours.textGrey, textAlign: "left" }}>
          Inverter Set {index}
        </Text>
        <Text style={{ color: "orange" }}>Details required</Text>
      </View>
    ) : (
      this.getSystemDetails()
    );

    const inverterSystemMainItem = (
      <TouchableOpacity
        style={{ ...styles.listItem, flex: 2, minWidth: 275 }}
        onPress={onSelected}
      >
        <View style={{ flex: 4, paddingLeft: 20 }}>{details}</View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {errorText}
          <Icon
            name={errorText ? "exclamation-circle" : "pencil"}
            size={24}
            color={needsFilling || errorText ? "orange" : RepositColours.blue}
            style={{ marginLeft: 5 }}
          />
        </View>
      </TouchableOpacity>
    );

    const swipeSettings = {
      autoClose: true,
      onClose: () => {
        if (this.state.activeRowKey != null) {
          this.setState({ activeRowKey: null });
        }
      },
      onOpen: () => {
        this.setState({ activeRowKey: this.props.key });
      },
      right: [
        {
          onPress: this.props.onSystemRemoved,
          text: "Delete",
          type: "delete",
        },
      ],
      rowId: this.props.index,
      sectionId: 1,
    };

    return (
      <View style={{ maxWidth: 450 }}>
        {Platform.OS !== "web" ? (
          <Swipeout style={{ backgroundColor: "white" }} {...swipeSettings}>
            {inverterSystemMainItem}
          </Swipeout>
        ) : (
          <View style={{ flexDirection: "row", display: "flex" }}>
            {inverterSystemMainItem}
            <TouchableOpacity
              onPress={this.props.onSystemRemoved}
              style={{
                flexDirection: "column",
                borderBottomColor: "#E2E2E2",
                borderBottomWidth: 1,
                height: 110,
                justifyContent: "center",
                backgroundColor: "#e25a33",
                minWidth: "83px",
              }}
            >
              <Icon
                name={"trash"}
                size={24}
                color={"black"}
                style={{ alignSelf: "center" }}
              />
            </TouchableOpacity>
          </View>
        )}
      </View>
    );
  }
}

class InverterSystemsList extends Component {
  systemToItem = ([uid, system], index) => {
    return {
      ...system,
      key: uid,
      index: index + 1,
      onSelected: () => this.props.onSystemSelected(uid),
      onSystemRemoved: () => this.props.onSystemRemoved(uid),
    };
  };

  render() {
    const {
      inverterSystems: systems,
      inverterTypes,
      batteryTypes,
      onSystemAdded,
    } = this.props;

    return (
      <View style={{ flex: 1 }}>
        {Platform.OS !== "web" ? (
          <FlatList
            style={{ maxHeight: 275 }}
            ref={(inverterSystemList) => {
              this.inverterSystemList = inverterSystemList;
            }}
            data={Object.entries(systems).map(this.systemToItem)}
            renderItem={({ item }) => (
              <InverterSystemItem
                {...item}
                inverterTypes={inverterTypes}
                batteryTypes={batteryTypes}
              />
            )}
          />
        ) : (
          <ScrollView
            style={{ overflowY: "auto", height: 275 }}
            ref={(inverterSystemList) => {
              this.inverterSystemList = inverterSystemList;
            }}
          >
            {Object.entries(systems)
              .map(this.systemToItem)
              .map((item) => (
                <InverterSystemItem
                  {...item}
                  inverterTypes={inverterTypes}
                  batteryTypes={batteryTypes}
                />
              ))}
          </ScrollView>
        )}
        <TouchableOpacity
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            paddingTop: 20,
          }}
          onPress={() => onSystemAdded(this.inverterSystemList)}
        >
          <Icon name="plus-circle" size={18} color={RepositColours.blue} />
          <Text
            style={{ color: RepositColours.blue, paddingLeft: 2, fontSize: 16 }}
          >
            Add Inverter
          </Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  edmiSerial: state.edmi.serial,
  hardware: state.designer.kit.hardware,
  design: state.designer.kit.design,
  inverters: state.designer.constraints.inverterTypes,
  batteries: state.designer.constraints.batteryTypes,
  loading: state.designer.kit.loading,
  // TODO mask if still loading constraints?
});

const mapDispatchToProps = (dispatch) => {
  return {
    designerActions: bindActionCreators(designerActions, dispatch),
  };
};

export class InverterSets extends Component {
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.hardware && !this.props.hardware) {
      goTo(nextProps.navigation, "KitSummary");
    }
  }

  handleInverterSystemAdded = (listToScroll) => {
    this.props.designerActions.addInverterSystem();
    if (Object.keys(this.props.design.inverterSystems).length > 1) {
      setTimeout(() => {
        listToScroll.scrollToEnd();
      }, 1);
    }
  };

  handleInverterSystemPress = (uid) => {
    this.props.designerActions.openInverterSystem(uid);
    // React navigation does a double-navigate if we try to go to the type list directly :(
    const destination =
      Platform.OS === "web" ? "ComponentList" : "ComponentStack";
    goTo(this.props.navigation, destination);
  };

  handleNext = () => {
    const { design, edmiSerial } = this.props;
    this.props.designerActions.updateKitHardware(null);
    this.props.designerActions.submitKitDesign(
      serializeDesign(design, edmiSerial)
    );
  };

  render() {
    if (
      Platform.OS === "web" &&
      this.props.path === "/InverterSets" &&
      !this.props.design.gridPhases.value
    ) {
      goBack();
      return null;
    }

    const {
      inverters,
      batteries,
      design: { inverterSystems },
      loading,
    } = this.props;
    // TODO loading
    return (
      <View style={styles.wrapper}>
        <WebHeading title="Inverters" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800, maxHeight: 600 }}>
            <View style={{ ...styles.bodyText, flex: 2 }}>
              <View style={{ flex: 1, justifyContent: "center" }}>
                <Text style={[RepositStyles.paragraphText]}>
                  Add information about each of the inverters to give us a good
                  idea of the site's requirements
                </Text>
              </View>
              <View
                style={{
                  alignItems: "stretch",
                  flex: 3,
                  justifyContent: "center",
                  borderTopWidth: StyleSheet.hairlineWidth,
                  borderTopColor: "#C8C7CC",
                }}
              >
                {inverterSystems ? (
                  <InverterSystemsList
                    inverterTypes={inverters}
                    batteryTypes={batteries}
                    inverterSystems={inverterSystems}
                    onSystemSelected={this.handleInverterSystemPress}
                    onSystemRemoved={
                      this.props.designerActions.removeInverterSystem
                    }
                    onSystemAdded={this.handleInverterSystemAdded}
                  />
                ) : null}
              </View>
              <View
                style={{
                  flexDirection: "column",
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 35,
                }}
              >
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <RNButton
                    title=" Next "
                    onPress={this.handleNext}
                    color={RepositColours.blue}
                  />
                )}
                <Text style={RepositStyles.nextSub}>Confirm Kit</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InverterSets);



// WEBPACK FOOTER //
// ./src/containers/kit/InverterSets.js